// The list and the report under edit both name a report type, so the type
// lives on the plural side. The singular library re-exports it, which is the
// direction ADR-0023 allows.
export enum ReportType {
  Anchor = 'Anchor',
  Sea = 'Sea',
  Departure = 'Departure',
  Port = 'Port',
  Maneuvering = 'Maneuvering',
  SeaArrival = 'Sea (Arrival)',
  Drifting = 'Drifting',
}

// The backend stores four of the types as a class. Each of the other three is
// one of those classes with one field set: a Departure is a Maneuvering report
// that departs, a Sea (Arrival) is a Sea report that arrives, and a Drifting is
// an Anchor report that drifts. This maps each type to the type of its class.
// The map goes one way only: a base type cannot say which derived type it is
// without that field.
export const REPORT_TYPE_BASE: Record<ReportType, ReportType> = {
  [ReportType.Sea]: ReportType.Sea,
  [ReportType.Port]: ReportType.Port,
  [ReportType.Anchor]: ReportType.Anchor,
  [ReportType.Maneuvering]: ReportType.Maneuvering,
  [ReportType.Departure]: ReportType.Maneuvering,
  [ReportType.SeaArrival]: ReportType.Sea,
  [ReportType.Drifting]: ReportType.Anchor,
};
